module.exports = __webpack_public_path__ + "img/success-icon.24022b5b.svg";